module.exports = require("winston");


//////////////////
// WEBPACK FOOTER
// external "winston"
// module id = 45
// module chunks = 0